import { addDoc, collection, doc } from "firebase/firestore";
import { db } from "../../../../firebase";
import { toast } from "react-hot-toast";
import { ref, uploadBytesResumable, getDownloadURL } from "firebase/storage";
import { storage } from "../../../../firebase";

export const createNewRentalApplication = async (
  data,
  companyName,
  mails,
  phNumbers,
  prevAddresses,
  pet,
  dep,
  creditCard,
  addIncome,
  bankAccount,
  filteredNotes,
  files
) => {
  Object.keys(data).forEach((field) => {
    if (data[field] === undefined) {
      data[field] = "";
    }
  });

  const companiesRef = collection(db, "companies");
  const companyDocRef = doc(companiesRef, companyName);
  const rentalApplicationRef = collection(companyDocRef, "rentalApplications");

  const uniqueIds = {}; // Helper object to keep track of seen ids
  const imagesUrl = []; // Helper object to keep track of seen ids
  const uniqueItems = files.filter((item) => {
    // If the id is not in the uniqueIds object, add it and return true
    if (!uniqueIds[item.uid]) {
      uniqueIds[item.uid] = true;
      return true;
    }
    // If the id is already in the uniqueIds object, return false to filter it out
    return false;
  });

  for (const file of uniqueItems) {
    const storageRef = ref(storage, `/files/rentalApplications/${file.name}`);
    const uploadTask = uploadBytesResumable(storageRef, file);

    try {
      await uploadTask;

      // File uploaded successfully
      const downloadURL = await getDownloadURL(uploadTask.snapshot.ref);
      const fileData = {
        downloadURL: downloadURL,
        id: file.uid,
        name: file.name,
        type: file.type,
        isDefault: false,
      };
      imagesUrl.push(fileData);
      console.log("Download URL for", file.name, ":", downloadURL);
    } catch (error) {
      console.error("Upload error for", file.name, ":", error);
    }
  }

  console.log("files", files);
  console.log("imagesUrlimagesUrlimagesUrl", imagesUrl);

  try {
    const information = {
      salutation: data.salutation || "",
      legalFirstName: data.legalFirstName || "",
      noMiddleName: data.noMiddleName || false,
      lastName: data.lastName || "",
      suffixes: data.suffixes || "",
      applicantType: data.applicantType || "",
      companyName: data.companyName || "",
      useCompanyName: data.useCompanyName || false,
      phoneNumbers: phNumbers,
      emails: mails,
    };

    await addDoc(rentalApplicationRef, {
      rentalUnit: {
        unit: data.unit,
        desiredMoveIn: data["desiredMoveIn"]
          ? data["desiredMoveIn"].format("DD-MM-YYYY")
          : "" || "",
      },

      residentialHistory: {
        currentAddress: {
          currentAddress1: data.currentAddress1 || "",
          currentAddress2: data.currentAddress2 || "",
          city: data.currentCity || "",
          state: data.currentState || "",
          zip: data.currentZip || "",
          country: data.currentCountry,
          residedFrom: data["currentResidedFrom"]
            ? data["currentResidedFrom"].format("DD-MM-YYYY")
            : "" || "",
          residedTo: data["currentResidedTo"]
            ? data["currentResidedTo"].format("DD-MM-YYYY")
            : "" || "",
          monthlyRent: data.currentMonthlyRent || "",
          landLordName: data.currentLandLordName || "",
          landLordNum: data.currentLandLordNum || "",
          landLordEmail: data.currentLandLordEmail || "",
          landLordReason: data.currentLandLordReason || "",
        },
        prevAddresses,
      },
      personalInformation: {
        dob: data.dob || "",
        ssn: data.ssn || "",
        govId: data.govId || "",
        issuingTerritory: data.issuingTerritory || "",
      },
      financialInformation: {
        bankAccName: data.bankAccName || "",
        bankAccType: data.bankAccType || "",
        bankAccNum: data.bankAccNum || "",
        bankAccBalance: data.bankAccBalance || "",
      },
      financialInformation: {
        creditCard,
        bankAccount,
      },

      Income: {
        employmentDetails: {
          employerName: data.employerName || "",
          employerPhone: data.employerPhone || "",
          employerAddress1: data.employerAddress1 || "",
          employerAddress2: data.employerAddress2 || "",

          employerCity: data.employerCity || "",
          employerState: data.employerState || "",
          employerZip: data.employerZip || "",
          employerCountry: data.employerCountry || "",

          employerMonthlySalary: data.employerMonthlySalary || "",
          employerPositionHeld: data.employerPositionHeld || "",
          employerYearsWorked: data.employerYearsWorked || "",
          employerSupervisorName: data.employerSupervisorName || "",
          employerSupervisorTitle: data.employerSupervisorTitle || "",
          SupervisorEmail: data.SupervisorEmail || "",
        },
        addIncome,
      },

      emergencyContact: {
        emergencyName: data.emergencyName || "",
        emergencyAddress: data.emergencyAddress || "",
        emergencyPhone: data.emergencyPhone || "",
        emergencyEmail: data.emergencyEmail || "",
        emergencyRelationShip: data.emergencyRelationShip || "",
      },
      questionOptionsa: {
        Atoured:
          data.Atoured === "true"
            ? "true"
            : data.Atoured === "false"
            ? "false"
            : "false",
        Aconvicted:
          data.Aconvicted === "true"
            ? "true"
            : data.Aconvicted === "false"
            ? "false"
            : "false",
        AfiledSuit:
          data.AfiledSuit === "true"
            ? "true"
            : data.AfiledSuit === "false"
            ? "false"
            : "false",
        AevictionLawsuit:
          data.AevictionLawsuit === "true"
            ? "true"
            : data.AevictionLawsuit === "false"
            ? "false"
            : "false",
        Aquestions:
          data.Aquestions === "true"
            ? "true"
            : data.Aquestions === "false"
            ? "false"
            : "false",
        AhousingAssistance:
          data.AhousingAssistance === "true"
            ? "true"
            : data.AhousingAssistance === "false"
            ? "false"
            : "false",
        AmaidenName:
          data.AmaidenName === "true"
            ? "true"
            : data.AmaidenName === "false"
            ? "false"
            : "false",
        AresidentBenefitPackage:
          data.AresidentBenefitPackage === "true"
            ? "true"
            : data.AresidentBenefitPackage === "false"
            ? "false"
            : "false",
        ApetProfile:
          data.ApetProfile === "true"
            ? "true"
            : data.ApetProfile === "false"
            ? "false"
            : "false",
        AmilitaryMember:
          data.AmilitaryMember === "true"
            ? "true"
            : data.AmilitaryMember === "false"
            ? "false"
            : "false",
        AleasePrepFee:
          data.AleasePrepFee === "true"
            ? "true"
            : data.AleasePrepFee === "false"
            ? "false"
            : "false",
        AsecurityDepositWaiver:
          data.AsecurityDepositWaiver === "true"
            ? "true"
            : data.AsecurityDepositWaiver === "false"
            ? "false"
            : "false",
      },
      information,
      dep,
      pet,
      notes: filteredNotes,
      attachments: imagesUrl,
    });
    toast.success("New rental Application created successfully!");
  } catch (error) {
    toast.error("Error in creating new rental Application..........:", error);
  }
};
